import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  UncontrolledTooltip,
} from "reactstrap";
import { isMobile } from "react-device-detect";
import { Notification, FullViewContainer } from "../common/style";
import ProjectDropDown from "./ProjectDropDown";
import CrudModal from "./CrudModal";
import {
  addUserRoom,
  addUserGroup,
  deleteUserRoom,
  updateUserProject,
  updateUserGroup,
  updateUserRoom,
} from "./service";
import { useNavigate } from "react-router-dom";
import SectionAccordion from "./SectionAccordion";
import NewOrder from "../order/NewOrder";
import ContactModal from "../product/ContactModal";
import Select from "react-select";

const VIEW_MODE_DISPLAY_NAMES = {
  default: "Design",
  spec: "Spec",
  review: "Review",
};

const NewProjectSummary = ({
  isLoading,
  setIsLoading,
  currentRoom,
  projectSummary,
  selectionManager,
  setCurrentGroup,
  projectId,
  loadRoom,
  setIsReset,
  hoverItem,
  setHoverItem,
  isEq,
  access,
  isOrderFinalised,
  refreshProjectSummary,
  mutateCurrentRoom,
  isAdmin,
  finalisedContexts,
  currentSelection,
  setCurrentSelection,
  setCurrentTab,
  setRoom,
  isCurrentTab,
  isDesigner,
  currentTab,
  isListProject,
  showRoomView = false,
  viewMode,
  setViewMode,
  camerView,
  setCameraView,
  wallView,
  setWallView,
}) => {
  const navigate = useNavigate();
  const [notification, setNotification] = useState({ type: "", message: "" });
  const [isNotificationVisible, setIsNotificationVisible] = useState(true);
  const [currentEditModalName, setCurrentEditModalName] = useState(null);
  const [roomDropdown, setRoomDropdown] = useState(false);
  const [editProject, setEditProject] = useState(false);
  const [addRoomModal, setAddRoomModal] = useState(false);
  const [editRoom, setEditRoom] = useState(false);
  const [addGroupModal, setAddGroupModal] = useState(false);
  const [editGroup, setEditGroup] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showTalkToUsModal, setShowTalkToUsModal] = useState(false);

  const toggleRoomDropdown = () => setRoomDropdown(!roomDropdown);

  const toggleEditProject = () => setEditProject(!editProject);

  const toggleAddRoom = () => setAddRoomModal(!addRoomModal);

  const toggleEditRoom = () => {
    setEditRoom(!editRoom);
  };

  const toggleAddGroup = () => setAddGroupModal(!addGroupModal);

  const toggleEditGroup = () => setEditGroup(!editGroup);

  const onDismissNotification = () => {
    setIsNotificationVisible(false);
  };

  const updateProject = ({ projectId, payload }) => {
    setIsLoading(true);

    return updateUserProject({ projectId, payload })
      .catch((err) => {
        if (err.cause && err.cause.code === 403) {
          navigate("/login_with_otp");
        } else {
          setIsNotificationVisible(true);
          setNotification({ type: "error", message: err.error });
        }
      })
      .finally((_) => setIsLoading(false));
  };

  const addRoom = (payload) => {
    setIsLoading(true);

    return addUserRoom({ projectId: projectId, payload })
      .then(({ room }) => {
        updateLocalProject({
          entityName: room.name,
          entityId: room.id,
          entity: "room",
          action: "add",
        });
        loadRoom(room.id);
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
      })
      .finally((_) => setIsLoading(false));
  };

  // Allowed Updates [Name]
  const updateRoom = ({ projectId, roomId, payload }) => {
    setIsLoading(true);

    return updateUserRoom({ projectId, roomId, payload })
      .then((_) => {
        updateLocalProject({
          entityName: payload.name,
          entityId: roomId,
          entity: "room",
          action: "update",
        });
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
      })
      .finally((_) => setIsLoading(false));
  };

  const deleteRoom = (projectId, roomId) => {
    setIsLoading(true);

    return deleteUserRoom({ projectId, roomId })
      .then((_) => {
        updateLocalProject({
          entityId: roomId,
          entity: "room",
          action: "delete",
        });
        refreshProjectSummary();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
      })
      .finally((_) => setIsLoading(false));
  };

  const addGroup = ({ projectId, roomId, payload }) => {
    setIsLoading(true);

    return addUserGroup({ projectId, roomId, payload })
      .then(({ group }) => {
        updateLocalProject({
          entity: "group",
          entityId: group.id,
          entityName: group.name,
          parentId: roomId,
          action: "add",
        });
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
      })
      .finally((_) => setIsLoading(false));
  };

  const updateGroup = ({ projectId, groupId, roomId, payload }) => {
    setIsLoading(true);

    return updateUserGroup({ projectId, groupId, payload })
      .then((_) => {
        updateLocalProject({
          entity: "group",
          entityId: groupId,
          entityName: payload.name,
          parentId: roomId,
          action: "update",
        });
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
      })
      .finally((_) => setIsLoading(false));
  };

  const updateLocalProject = ({
    entity = "room",
    entityId,
    entityName,
    parentId = null, // roomId for entity 'Group'
    action,
  }) => {
    if (entity === "room") {
      return updateLocalRoom({
        roomName: entityName,
        roomId: entityId,
        action,
      });
    }

    if (entity === "group") {
      return updateLocalGroup({
        groupId: entityId,
        groupName: entityName,
        roomId: parentId,
        action,
      });
    }
  };

  const updateLocalRoom = ({ roomName, roomId, action }) => {
    switch (action) {
      case "add": {
        projectSummary.rooms.push({ id: roomId, name: roomName });

        break;
      }
      case "update": {
        const roomIndex = projectSummary.rooms.findIndex(
          (room) => room.id === roomId
        );
        projectSummary.rooms[roomIndex] = {
          ...projectSummary.rooms[roomIndex],
          name: roomName,
        };

        break;
      }
      case "delete": {
        projectSummary.rooms = projectSummary.rooms.filter(
          (room) => room.id !== roomId
        );

        if (projectSummary.rooms?.length) {
          loadRoom(projectSummary.rooms[0].id);
        }

        break;
      }
    }
  };

  const updateLocalGroup = ({ roomId, groupName, groupId, action }) => {
    // Mutating "project" -> To update the group names in module "Add To Room" CTA
    switch (action) {
      case "add": {
        currentRoom.groups.push({
          id: groupId,
          name: groupName,
          modules: [],
          position: { x: 0, y: 0 },
          dimensions: { height: 0, width: 0, depth: 0 },
          type: "group",
          category: "StackedGroup",
        });

        break;
      }
      case "update": {
        const groupIndex = currentRoom.groups.findIndex(
          (group) => group.id == groupId
        );

        currentRoom.groups[groupIndex].name = groupName;
        currentRoom.groups[groupIndex] = {
          ...currentRoom.groups[groupIndex],
          name: groupName,
        };

        break;
      }
      case "delete": {
        currentRoom.groups = currentRoom.groups.filter(
          (group) => group.id !== groupId
        );

        loadRoom(currentRoom.id);

        break;
      }
    }
  };

  const getOrderItems = (items, orderItems = []) => {
    const [itemValue] = Object.values(items);
    const itemKeys = Object.keys(items);

    if (typeof itemValue === "boolean") {
      return orderItems.push(itemKeys);
    }

    for (const item in items) {
      getOrderItems(items[item], orderItems);
    }

    return orderItems.flat();
  };

  return (
    <div
      className={`position-relative z-3 ${
        viewMode === "review" || viewMode === "spec" ? "w-100" : ""
      }`}
    >
      <div
        className="fh left-pane bg-white overflow-visible shadow-right d-flex flex-column"
        style={{
          width: showRoomView
            ? "auto"
            : viewMode === "review" || viewMode === "spec"
            ? "100%"
            : isMobile
            ? "100vw"
            : viewMode === "spec"
            ? "1000px"
            : viewMode === "remarks"
            ? "1000px"
            : "485px",
        }}
      >
        {notification.type && (
          <Notification
            color={notification.type === "error" ? "danger" : "success"}
            isOpen={isNotificationVisible}
            toggle={onDismissNotification}
          >
            {notification.message}
          </Notification>
        )}

        {currentRoom &&
          projectSummary &&
          (isCurrentTab("order") && isMobile ? (
            <>
              <div className="d-flex justify-content-between align-items-center border-bottom p-3">
                <p className="fw-bold fs-6 m-0 text-capitalize">{currentTab}</p>
                <i
                  onClick={() => setCurrentTab("info")}
                  className="fa-solid fa-xmark fs-4 pointer text-secondary"
                />
              </div>
              <NewOrder
                isAdmin={isAdmin}
                isDesigner={isDesigner}
                currentRoom={currentRoom}
                loadRoom={loadRoom}
                projectSummary={projectSummary}
                setCurrentTab={setCurrentTab}
                access={access}
              />
            </>
          ) : (
            currentRoom &&
            projectSummary && (
              <FullViewContainer
                className={`${
                  isLoading ? "blurred" : ""
                } flex-grow-1 d-flex flex-column`}
              >
                <CrudModal
                  isOpen={editProject}
                  toggle={toggleEditProject}
                  crudAction={(projectId, _, payload) =>
                    updateProject({ projectId, payload })
                  }
                  id={projectId}
                  name={currentEditModalName}
                  text="Edit project Name"
                />
                <CrudModal
                  isOpen={addRoomModal}
                  toggle={toggleAddRoom}
                  crudAction={(projectId, _, payload) => addRoom(payload)}
                  id={projectId}
                  text="Add Room"
                />
                <CrudModal
                  isOpen={editRoom}
                  toggle={toggleEditRoom}
                  crudAction={(projectId, roomId, payload) =>
                    updateRoom({ projectId, roomId, payload })
                  }
                  id={projectId}
                  roomId={currentRoom.id}
                  name={currentEditModalName}
                  text="Edit Room Name"
                />
                <CrudModal
                  isOpen={addGroupModal}
                  toggle={toggleAddGroup}
                  crudAction={(projectId, roomId, payload) =>
                    addGroup({ projectId, roomId, payload })
                  }
                  id={projectId}
                  roomId={currentRoom.id}
                  text="Add Group"
                />

                {editGroup && (
                  <CrudModal
                    isOpen={editGroup}
                    toggle={toggleEditGroup}
                    crudAction={(projectId, groupId, payload) =>
                      updateGroup({
                        projectId,
                        groupId,
                        roomId: currentRoom.id,
                        payload,
                      })
                    }
                    id={projectId}
                    name={currentEditModalName}
                    groupId={selectionManager.selectedGroup()?.id}
                    text="Edit Group"
                  />
                )}

                <div className="bg-light-grey d-flex flex-wrap justify-content-between align-items-center px-2 py-2 pe-2">
                  <div className="d-flex gap-3">
                    <Select
                      classNamePrefix="react-select"
                      value={{
                        label: currentRoom.name,
                        value: currentRoom.id,
                        has_module_errors: currentRoom.has_module_errors,
                      }}
                      options={
                        projectSummary.rooms?.map((room) => ({
                          label: (
                            <div>
                              {room.name}
                              {room.has_module_errors && (
                                <i className="fa-solid fa-circle-exclamation ps-2 text-danger" />
                              )}
                            </div>
                          ),
                          value: room.id,
                          has_module_errors: room.has_module_errors,
                        })) || []
                      }
                      onChange={(selectedOption) => {
                        loadRoom(
                          selectedOption.value,
                          null,
                          null,
                          false,
                          null,
                          true
                        );
                        selectionManager.clear();
                      }}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      formatOptionLabel={(option, { context }) => {
                        if (context === "value") {
                          return (
                            <div
                              style={{
                                position: "relative",
                                minWidth: "60px",
                              }}
                            >
                              {option.label}
                              {option.has_module_errors && (
                                <>
                                  <i
                                    id={`room-error-icon-${option.value}`}
                                    className="fa-solid fa-circle-exclamation text-danger position-absolute top-50 end-0 translate-middle-y fs-6"
                                  />

                                  <UncontrolledTooltip
                                    target={`room-error-icon-${option.value}`}
                                    placement="left"
                                  >
                                    One or more modules in this room have some
                                    errors.
                                  </UncontrolledTooltip>
                                </>
                              )}
                            </div>
                          );
                        }

                        return (
                          <div className="d-flex align-items-center gap-3">
                            <span>{option.label}</span>
                          </div>
                        );
                      }}
                    />

                    {!showRoomView && (
                      <div className="d-flex align-items-center gap-2">
                        <div
                          className="d-flex border rounded-pill bg-white"
                          style={{
                            overflow: "hidden",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                          }}
                        >
                          {["default", "spec", "review"].map((state) => (
                            <button
                              key={state}
                              onClick={() => setViewMode(state)}
                              className={`px-3 py-1 border-0 fw-bold text-capitalize ${
                                viewMode === state
                                  ? "bg-primary text-white"
                                  : "bg-white text-dark"
                              }`}
                              style={{
                                cursor: "pointer",
                                transition: "all 0.2s ease",
                                fontSize: "0.875rem",
                              }}
                            >
                              {VIEW_MODE_DISPLAY_NAMES[state] || state}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="d-flex column-gap-2 align-items-center">
                    {!showRoomView &&
                      currentRoom.price &&
                      currentRoom.price != 0 && (
                        <p className="m-0 fw-bold">
                          ₹{currentRoom.price.toLocaleString("en-IN")}
                        </p>
                      )}
                    {access.add_room && !showRoomView && (
                      <ProjectDropDown
                        isOpen={roomDropdown}
                        toggle={() => {
                          setCurrentEditModalName(currentRoom.name);
                          toggleRoomDropdown();
                        }}
                        id={projectId}
                        roomId={currentRoom.id}
                        text="Room"
                        bgcolor="white !important"
                        onDelete={deleteRoom}
                        toggleAddModal={toggleAddRoom}
                        toggleModal={toggleEditRoom}
                        isOrderFinalised={isOrderFinalised}
                        loadRoom={loadRoom}
                        projectSummary={projectSummary}
                        selectionManager={selectionManager}
                      />
                    )}
                  </div>
                </div>

                <div
                  className="flex-grow-1"
                  style={{
                    overflowY: isMobile ? "auto" : "",
                    paddingBottom: showPreview && isMobile ? "20px" : "0",
                  }}
                >
                  <SectionAccordion
                    key={
                      showRoomView ? "room-view-active" : "room-view-inactive"
                    }
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    currentRoom={currentRoom}
                    projectSummary={projectSummary}
                    selectionManager={selectionManager}
                    setCurrentGroup={setCurrentGroup}
                    projectId={projectId}
                    loadRoom={loadRoom}
                    setIsReset={setIsReset}
                    hoverItem={hoverItem}
                    setHoverItem={setHoverItem}
                    isEq={isEq}
                    access={access}
                    isorderfinalised={isOrderFinalised}
                    fromOrderReview={false}
                    refreshProjectSummary={refreshProjectSummary}
                    mutateCurrentRoom={mutateCurrentRoom}
                    isAdmin={isAdmin}
                    finalisedContexts={finalisedContexts}
                    currentSelection={currentSelection}
                    setCurrentSelection={setCurrentSelection}
                    setCurrentTab={setCurrentTab}
                    setRoom={setRoom}
                    viewMode={viewMode}
                    showPreview={showPreview}
                    isListProject={isListProject}
                    showRoomView={showRoomView}
                    cameraView={camerView}
                    setCameraView={setCameraView}
                    wallView={wallView}
                    setWallView={setWallView}
                  />
                </div>

                {showPreview && (
                  <div
                    className="position-relative w-100 bg-light"
                    style={{
                      zIndex: 20,
                      boxShadow: "0 -4px 12px rgba(0, 0, 0, 0.15)",
                    }}
                  >
                    {isMobile && (
                      <div
                        className="position-absolute start-0 me-2 d-flex align-items-center justify-content-center text-white fw-bold p-1 rounded-top cursor-pointer bg-primary preview-btn"
                        onClick={() => setShowTalkToUsModal(true)}
                        style={{
                          fontSize: "0.75rem",
                          zIndex: 25,
                          cursor: "pointer",
                          top: "-25px",
                        }}
                      >
                        <i className="fa-solid fa-phone me-1"></i>
                        <span>Talk to us</span>
                      </div>
                    )}
                    {isMobile && (
                      <div
                        className="position-absolute end-0 me-2 d-flex align-items-center justify-content-center text-white fw-bold p-1 rounded-top cursor-pointer bg-primary preview-btn"
                        onClick={() => setShowPreview(false)}
                        style={{
                          fontSize: "0.75rem",
                          zIndex: 25,
                          cursor: "pointer",
                          top: "-25px",
                        }}
                      >
                        <i className="fa-solid fa-chevron-down me-1"></i>
                        <span>Preview</span>
                      </div>
                    )}
                  </div>
                )}
                {!showPreview && isMobile && (
                  <div
                    className="position-fixed bottom-0 start-0 mx-2 d-flex align-items-center justify-content-center text-white fw-bold p-1 rounded-top cursor-pointer bg-primary preview-btn"
                    onClick={() => setShowTalkToUsModal(true)}
                    style={{
                      fontSize: "0.75rem",
                      zIndex: 1000,
                      cursor: "pointer",
                    }}
                  >
                    <i className="fa-solid fa-phone me-1"></i>
                    <span>Talk to us</span>
                  </div>
                )}
                {!showPreview && isMobile && (
                  <div
                    className="position-fixed bottom-0 end-0 mx-2 d-flex align-items-center justify-content-center text-white fw-bold p-1 rounded-top cursor-pointer bg-primary preview-btn"
                    onClick={() => setShowPreview(true)}
                    style={{
                      fontSize: "0.75rem",
                      zIndex: 25,
                      cursor: "pointer",
                    }}
                  >
                    <i className="fa-solid fa-chevron-up me-1"></i>
                    <span>Preview</span>
                  </div>
                )}

                <Modal isOpen={showModal} toggle={() => setShowModal(false)}>
                  <ModalHeader toggle={() => setShowModal(false)}>
                    How Boxs works?
                  </ModalHeader>
                  <ModalBody></ModalBody>
                  <ModalFooter>
                    <Button color="primary" onClick={() => setShowModal(false)}>
                      Got it
                    </Button>
                  </ModalFooter>
                </Modal>

                <ContactModal
                  isOpen={showTalkToUsModal}
                  toggle={() => setShowTalkToUsModal(false)}
                />
              </FullViewContainer>
            )
          ))}
      </div>
    </div>
  );
};

export default NewProjectSummary;
